import React, { FC } from 'react'
import Favorite from './Favorite'
import AddToCollection from './AddToCollection'
import AddToCart from './AddToCart'
import styles from './Actions.module.scss'
import { GA4CartEventObject } from './useAddToCart'
import EditArtwork from './EditArtwork'
import useQA from 'hooks/useQA'

type PolaroidActionsProps = {
  artworkId: number
  sku: string
  status: string
  price: number
  productEvent?: GA4CartEventObject
  shouldShowEditIcon?: boolean
  customPromoCode?: string
  shouldSendAlgoliaEvents?: boolean
  isAddToCartVisible?: boolean
}

const PolaroidActions: FC<PolaroidActionsProps> = ({
  artworkId,
  sku,
  status,
  price,
  productEvent,
  shouldShowEditIcon,
  customPromoCode,
  shouldSendAlgoliaEvents,
  isAddToCartVisible = true,
}) => {
  const { testId } = useQA()
  return (
    <div className={styles.polaroidActionsContainer} {...testId('polaroid-actions-container')}>
      {shouldShowEditIcon ? (
        <EditArtwork artworkId={artworkId} />
      ) : (
        <Favorite artworkId={artworkId} />
      )}

      <AddToCollection artworkId={artworkId} />
      {isAddToCartVisible && (
        <AddToCart
          artworkId={artworkId}
          sku={sku}
          status={status}
          price={price}
          productEvent={productEvent}
          customPromoCode={customPromoCode}
          shouldSendAlgoliaEvents={shouldSendAlgoliaEvents}
        />
      )}
    </div>
  )
}

export default PolaroidActions
